import { API, store } from './utils'

/*
* First visit. No auth. Send to Gumroad then back here.
* Visit with oauth code. Get tokens, save to local storage, and auth.
* Visit with localStorage. auth. If failed, send to gumroad.
* */

export const noAuthSendToGumroad = () => {
  const next = encodeURIComponent(`/oauth/authorize?client_id=${API.client_id}&redirect_uri=${API.redirect_url}&scope=&response_type=code`)
  window.location.href = `https://gumroad.com/oauth/login?next=${next}`
}

export const haveTokensCheckSubscription = (access_token, refresh_token) => {
  return fetch(`${API.endpoint}/check_subscription`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ access_token, refresh_token })
    }).then(response => response.json())
    .then(sekrets => {
      store.vimeoIds = sekrets
    })
}

export const oauthInProgressGetTokens = code => {
  return fetch(`${API.endpoint}/login`, {
    method: 'POST',
    headers: {
      'Accept': 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ code })
  }).then(response => response.json())
    .then((response) => {
      const {access_token, refresh_token} = response
      if (access_token && refresh_token) {
        store.auth = {accessToken: access_token, refreshToken: refresh_token}
        haveTokensCheckSubscription(access_token, refresh_token)
      } else {
        console.error(response)
        store.loginFailed = true
      }
    })
}



/** WEBPACK FOOTER **
 ** ./src/lib/gumroad.js
 **/